import React from 'react';
import { Modal } from 'antd';

import './styles.scss';


const PaidDateModal = ({
  open, onCancel, onContinue, onShowRules,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      style={{
        maxWidth: 'min-content',
      }}
    >
      <div className='paid-date-modal'>
        <p className='paid-date-text'>
          Бронирование стола на эту дату платное – 500 руб.
        </p>
        <p className='paid-date-link'>
          Ознакомитесь с<br/>
          <span onClick={onShowRules}>Правилами бронирования</span>
        </p>
        <button
          type='button'
          className='paid-date-continue'
          onClick={onContinue}
        >Продолжить</button>
        <p className='paid-date-caption'>
          Нажимая «продолжить», вы соглашаетесь с правилами
        </p>
      </div>
    </Modal>
  )
}

export default PaidDateModal;
